export class MaintenanceLogQueryModel {
    constructor(query, dateFilterOption) {
        this.query = query || null;
        this.dateFilterOption = dateFilterOption || null;
    }
}
